export const SET_BOOKMARK = "SET_BOOKMARKS";
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_SEARCH_HISTORY = "SET_SEARCH_HISTORY";
export const SET_ARTICLES = "SET_ARTICLES";
export const SET_READ = "SET_READ";
